import React, { useState, useEffect } from "react";
import "./index.scss";
import SHU_TIAO from "@/assets/images/shutiao.png";
import { Toast,ImagePicker, Button, NoticeBar, Card, DatePicker } from "antd-mobile";
import { packDate } from "@/utils/getDate";
import { fileUpload, addDriverAntiepidemic } from "@/api";
import { createNonceStr, md5,getLocationSearch } from "@/utils/utils";
import request from "@/utils/request";
import Header from '@/components/header/common'
import qs from "qs";

const GvcPlace = (props) => {
  let { history, location } = props;
  // let arr = location.search.split("?");
  // let { token } = qs.parse(arr[1]);
  let token = getLocationSearch().token
  let appKey = "app_h5";
  let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
  let timestamp = new Date().getTime();
  let random = createNonceStr();
  let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
  let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
  const params = {
    appKey: appKey,
    timestamp: timestamp,
    random: random,
    token: token,
    sign: sign,
  };
  const handleGoGvc = () => {
    // history.push(`/gvc?token=${token}`);
    history.push(`/gvc`);
  };
  let [reportFiles, setReportFiles] = useState([]);
  let [date, setDate] = useState("");
  // let [des, setDes] = useState("还未上传新冠疫苗接种记录，请尽快上传");
  // let [isReportError, setIsReportError] = useState(false);
  const onChangeDate = (val) => {
    setDate(val);
  };
  const dateText = (val) => {
    return val ? packDate(val) : "请选择";
  };
  const fileUp = async (file) => {
    console.log(file, "sssss");
    Toast.loading('loading...',0,()=>{},true)
    const res = await request.post(fileUpload, file, {
      ...params,
      "Content-Type": "application/x-www-form-urlencoded",
    });
    Toast.hide()
    if (res.data.data) {
      return res.data.data.ossKey;
    }
    return false;
  };
  const onChangeProveFiles = async (files, type, index) => {
    if (files.length > 0) {
      const formData = new FormData();
      formData.append("file", files[0].file);
      formData.append("fileType", "BIZLICENT_IMG");
      let ossKey = await fileUp(formData);
      if (ossKey) {
        files[0].ossKey = ossKey;
      } else {
        files = [];
      }
    }
    setReportFiles(files);
  };
  const submit = async() => {
    if (reportFiles.length < 1) {
      Toast.offline("图片未上传，请检查并重新上传!!!");
      return;
    }
    // if (date.length < 1) {
    //   Toast.offline("接种次数未选择，请检查并修改!!!");
    //   return;
    // }
    console.log(reportFiles[0].ossKey,"proveFiles[0].ossKey")
    Toast.loading('loading...',0,()=>{},true)
    const res = await request.post(addDriverAntiepidemic, {
      antiepidemicType:3,
      pictureUrl:reportFiles[0].ossKey,
    }, params);
    Toast.hide()
    if (res.data.data) {
      Toast.success("提交成功!");
      setTimeout(handleGoGvc, 2000);
    }else if(res.data.errorMsg){
      Toast.offline(res.data.errorMsg);
    }
  };
  useEffect(() => {
    document.title = "场所码";
  }, []);

  return (
    <div className="GvcProve_box">
      <Header tit='场所码' handleGoBackHeader={handleGoGvc}></Header>
      <NoticeBar
        className="notice_bar"
        marqueeProps={{ loop: true, style: { padding: "0 0.4rem" } }}
      >
        请确保上传真实有效的信息，若上传虚假信息将可能永久封禁；如因未能提供真实信息，造成的严重后果
        本人将承担相应的法律责任
      </NoticeBar>
      <Card className="card_info">
        <Card.Header title="场所码" thumb={SHU_TIAO} />
        <Card.Body>
          <div className="card-body">
            <div className="tips">
              请上传您车内张贴场所码的图片
            </div>
            <div className="img_box">
              <ImagePicker
                length="1"
                files={reportFiles}
                onChange={onChangeProveFiles}
                onImageClick={(index, fs) => console.log(index, fs)}
                selectable={reportFiles.length < 1}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
      <Button
        type="primary"
        className="btn"
        disabled={reportFiles.length == 0}
        onClick={submit}
      >
        确认并提交
      </Button>
    </div>
  );
};
export default GvcPlace;
